/* eslint-disable react/no-multi-comp, react/prop-types */
import { Link } from 'react-router';
import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';

import ActionSection from 'components/page/action-section';


// Components
export function Tabs({ children }) {
  return (
    <ActionSection className="actions-tabs">
      {children}
    </ActionSection>
  );
}

export function Tab({ className, to, children, ...props }, { router }) {
  const isActive = router.isActive;
  const classes = classNames(className, 'tab', { active: isActive(to) });

  return (
    <Link {...props} to={to} className={classes}>
      {children}
    </Link>
  );
}

Tab.contextTypes = {
  router: PropTypes.object
};
